/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import React, { Fragment, useContext } from "react";
// import { Grid } from '@mui/material'
import { ContentZoneContext } from "cms/components/context";
import { isArrayNotEmpty } from "utils/empty-exists";
import { EmptyContentMessage } from "cms/components/layout/empty/empty-content-message";
import { IconListItemCard } from "cms/components/components/icon-links-list/display/icon-list-item-card";

const IconLinkListComponentDisplay = () => {
    
    const { component } = useContext(ContentZoneContext);
    const { icon_links, title, settings } = component || {};
    const hasContent = isArrayNotEmpty(icon_links);
    let listStyle = "";
    const variant = "card";
    // const variant = 'vertical'
    if (variant === "card") {
        listStyle = "icon-link-cards";
    } else {
        listStyle = "icon-link-vertical";
    }
    return (
        <div className='link-list-container'>
            {hasContent &&
                <Fragment>
                    <div className='common-tasks-title icon-link-title'>{title}</div>
                    <div className={listStyle}>
                        {icon_links.map((icon_link, index) => (
                            <IconListItemCard
                                key={index}
                                index={index}
                                icon_link={icon_link}
                                settings={settings}
                            />
                        ))}
                    </div>
                </Fragment>
            }
            {!hasContent &&
                <EmptyContentMessage hasContent={hasContent} component={component} />
            }
        </div>
    );
};

IconLinkListComponentDisplay.displayName = "IconLinkListComponentDisplay";
export { IconLinkListComponentDisplay };
